import { useState, useEffect } from 'react';
import { IconSendFilled, IconCircleCheckFilled } from '@tabler/icons-react';
import supportResponses from '../data/supportResponses.json';


function renderMarkdown(text) {
  if (!text) return '';
  let html = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  // bold
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  // line breaks
  html = html.replace(/\n/g, ' ');
  return html;
}

const FONT = '"Public Sans", sans-serif';

const CATEGORIES = ['Recomendación', 'Queja', 'Sugerencia', 'Otro'];

const COMMON_ISSUES = supportResponses.map((r) => r.issue);

export default function ReporteIncidencias() {
  const [category, setCategory] = useState('Recomendación');
  const [selected, setSelected] = useState(null);
  const [typed, setTyped] = useState('');
  const [message, setMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  // Typing effect for selected issue response
  useEffect(() => {
    if (!selected) {
      setTyped('');
      return;
    }
    const entry = supportResponses.find((r) => r.issue === selected);
    const text = entry ? entry.response : '';
    setTyped('');
    let i = 0;
    const timer = setInterval(() => {
      i += 1;
      setTyped(text.slice(0, i));
      if (i >= text.length) clearInterval(timer);
    }, 18);
    return () => clearInterval(timer);
  }, [selected]);

  const handleSend = () => {
    const text = [
      `Tipo: ${category}`,
      selected ? `Motivo: ${selected}` : '',
      message.trim() ? `Descripción: ${message.trim()}` : '',
    ]
      .filter(Boolean)
      .join('\n');
    const url = `https://wa.me/529993661475?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank');
    setShowSuccess(true);
  };

  return (
    <div className="flex flex-col h-screen bg-black overflow-hidden">
      <header className="shrink-0 px-4 lg:px-6 pt-5 pb-4 border-b border-white/[0.16]">
        <h1 className="font-semibold m-0" style={{ fontSize: '22px', lineHeight: '28px', letterSpacing: '-0.02em', color: 'rgba(255,255,255,0.95)', fontFamily: FONT }}>
          Centro de ayuda
        </h1>
        <p className="m-0 mt-1" style={{ fontSize: '13px', lineHeight: '18px', fontWeight: 500, color: 'rgba(255,255,255,0.45)', fontFamily: FONT }}>
          Soporte 24/7. Revisamos tus tickets durante el día.
        </p>
      </header>

      <div className="flex-1 min-h-0 overflow-y-auto pedidos-scroll px-4 lg:px-6 py-5">
        <div className="grid gap-4 lg:grid-cols-2">
          <div className="rounded-3xl p-4 flex flex-col gap-3" style={{ backgroundColor: 'rgba(255,255,255,0.035)' }}>
            <h2 className="font-semibold m-0" style={{ fontSize: '16px', color: 'rgba(255,255,255,0.9)', fontFamily: FONT }}>
              Motivos más comunes
            </h2>
            <div className="flex flex-wrap gap-2">
              {COMMON_ISSUES.map((issue) => (
                <button
                  key={issue}
                  type="button"
                  onClick={() => setSelected(issue)}
                  className="h-10 px-4 rounded-full border-none cursor-pointer transition-colors duration-200"
                  style={{
                    backgroundColor: selected === issue ? '#fff' : 'rgba(255,255,255,0.06)',
                    color: selected === issue ? '#000' : 'rgba(255,255,255,0.7)',
                    fontSize: '13px',
                    fontWeight: 600,
                    fontFamily: FONT,
                  }}
                >
                  {issue}
                </button>
              ))}
            </div>

            {selected && (
              <div className="rounded-2xl p-3" style={{ backgroundColor: 'rgba(255,255,255,0.04)' }}>
                <p className="m-0" style={{ fontSize: '13px', fontWeight: 500, color: 'rgba(255,255,255,0.8)', fontFamily: FONT, minHeight: '40px' }} dangerouslySetInnerHTML={{ __html: renderMarkdown(typed) + '<span style="opacity:0.6">|</span>' }} />
              </div>
            )}

            <h2 className="font-semibold m-0 mt-2" style={{ fontSize: '16px', color: 'rgba(255,255,255,0.9)', fontFamily: FONT }}>
              Tipo de contacto
            </h2>
            <div className="flex flex-wrap gap-2">
              {CATEGORIES.map((c) => (
                <button
                  key={c}
                  type="button"
                  onClick={() => setCategory(c)}
                  className="h-10 px-4 rounded-full border-none cursor-pointer transition-colors duration-200"
                  style={{
                    backgroundColor: category === c ? '#fff' : 'rgba(255,255,255,0.06)',
                    color: category === c ? '#000' : 'rgba(255,255,255,0.7)',
                    fontSize: '13px',
                    fontWeight: 600,
                    fontFamily: FONT,
                  }}
                >
                  {c}
                </button>
              ))}
            </div>

            <h2 className="font-semibold m-0 mt-2" style={{ fontSize: '16px', color: 'rgba(255,255,255,0.9)', fontFamily: FONT }}>
              Descripción detallada
            </h2>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Si tu caso no está arriba, descríbelo aquí..."
              rows={5}
              className="w-full outline-none bg-white/[0.08] focus:bg-white/[0.12] resize-y"
              style={{
                border: 'none',
                borderRadius: '16px',
                padding: '14px 16px',
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: FONT,
                color: 'rgba(255,255,255,0.95)',
              }}
            />

            <button
              type="button"
              onClick={handleSend}
              className="flex items-center justify-center gap-2 h-12 px-6 rounded-full border-none cursor-pointer font-semibold transition-all duration-200 active:scale-[0.98] self-start"
              style={{ backgroundColor: '#0071e3', color: '#fff', fontSize: '14px', fontFamily: FONT, letterSpacing: '-0.01em' }}
            >
              <IconSendFilled size={16} />
              Enviar
            </button>
          </div>

          <div className="rounded-3xl p-4 flex flex-col gap-3" style={{ backgroundColor: 'rgba(255,255,255,0.035)' }}>
            <h2 className="font-semibold m-0" style={{ fontSize: '16px', color: 'rgba(255,255,255,0.9)', fontFamily: FONT }}>
              Chat con IA (próximamente)
            </h2>
            <div className="flex-1 min-h-[200px] rounded-2xl flex items-center justify-center" style={{ backgroundColor: 'rgba(255,255,255,0.03)' }}>
              <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)', fontFamily: FONT }}>
                Próximamente disponible
              </span>
            </div>
          </div>
        </div>
      </div>

      {showSuccess && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center p-3"
          style={{ backgroundColor: 'rgba(0,0,0,0.72)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)' }}
          onClick={() => setShowSuccess(false)}
        >
          <div
            role="dialog"
            aria-modal="true"
            className="flex flex-col items-center justify-center gap-6 w-full"
            style={{ backgroundColor: '#000', borderRadius: '28px', border: '1px solid rgba(255,255,255,0.16)', maxWidth: '420px', padding: '40px 24px', boxShadow: '0 40px 120px rgba(0,0,0,0.8)' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-center w-[80px] h-[80px] rounded-full" style={{ backgroundColor: 'rgba(48,209,88,0.12)' }}>
              <IconCircleCheckFilled size={40} color="#30d158" />
            </div>
            <div className="flex flex-col items-center gap-1 text-center">
              <span style={{ fontSize: '22px', lineHeight: '28px', fontWeight: 600, letterSpacing: '-0.02em', color: 'rgba(255,255,255,0.95)', fontFamily: FONT }}>
                Ticket recibido
              </span>
              <span style={{ fontSize: '14px', fontWeight: 500, color: 'rgba(255,255,255,0.45)', fontFamily: FONT }}>
                Revisaremos tu caso durante el día. Soporte 24/7.
              </span>
            </div>
            <button
              type="button"
              onClick={() => setShowSuccess(false)}
              className="flex items-center justify-center rounded-full border-none cursor-pointer font-semibold transition-all duration-200 active:scale-[0.98]"
              style={{ height: '44px', padding: '0 28px', backgroundColor: '#0071e3', color: '#fff', fontSize: '14px', fontFamily: FONT }}
            >
              Continuar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
